import React, { useState, useEffect } from "react";
import axios from 'axios';
import st from "../../../style.module.scss";
import cx from "./Teachingadd.module.scss";
import { NavLink, useHistory } from "react-router-dom";
import { Col, Row, Form, InputGroup } from "react-bootstrap";
import { MdArrowBackIos } from "react-icons/md";
import "bootstrap/dist/css/bootstrap.min.css";
import bg from "../../../images/bg-img-new.svg";
import logo from "../../../images/logo.png";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactLoading from "react-loading";
import Select from 'react-select'
import { RotatingLines } from "react-loader-spinner";

export default function Teachingadd(props: any) {
  let localData = JSON.parse(localStorage.getItem("userData")!);

  //---react-toastify---//
  const [timenotify, setTimenotify] = useState("");
  const [onetimenotify, setOnetimenotify] = useState(false);

  useEffect(() => {
    if (onetimenotify) {
      notify(timenotify);
      setTimeout(() => {
        setOnetimenotify(false);
      }, 3000);
    }
  }, [onetimenotify]);
  const notify = (message: String) =>
    toast(message, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
    });
  const navigate = useHistory();
  const [type, setType] = useState("1");
  const [fees, setFees] = useState("");
  const [subjectorcourses, setsubjectorcourses] = useState<any>([]);
  const [ClassorCategoryId, setClassorCategoryId] = useState<number>(0);
  const [SubjectorCourseId, setSubjectorCourseId] = useState<number>(0);
  const [loadingSpinner, setLoadingSpinner] = useState<any>('Save')
  const [classData, setClassData] = useState<any>([]);
  // const [subject, setSubject] = useState<any>([]);
  // const [course, setCourse] = useState<any>([]);
  // const [categoryDetailsLength, setCategoryDetailsLength] = useState<number>(0);

  const [loaderStatus, setloaderStatus] = useState(
    <ReactLoading type="cylon" color="blue" />
  );

  useEffect(() => {
    getallclscategory();
  }, [])
  let formdata = new FormData();

  // ----------------------------- GET ALL CLASS CATEGORY API------------------------------ //
  function getallclscategory() {

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BASEURL}/get_all_class_subject_categories_course`,
      headers: {
        "Authorization": "Bearer" + localStorage.getItem("api_token"),
      },
      data: formdata,
    };

    axios(config)
      .then(function (response) {
        if (response.data.statusCode == 200) {
          let classcategories: any[] = [];
          response.data.data.categoryDetails?.forEach((subelement: any, index: number) => {
            classcategories.push({ extraData: subelement?.courseDetails, label: subelement?.name, value: subelement?.id, uniqueId: subelement?.id, type: 'categories' })
          });
          response.data.data?.classDetails?.forEach((subelement: any, index: number) => {
            classcategories.push({ extraData: subelement?.subjectDetails, label: subelement?.class_name, value: `${subelement?.id + response.data.data.categoryDetails.length}`, uniqueId: subelement?.id, type: 'class' })
          });
          setClassData(classcategories)
          // setCategoryDetailsLength(response.data.data.categoryDetails.length)
          // setSubject(subjects);
          // setCourse(courses);
        }
        else {
          setTimenotify(response.data.message);
        }
      })
      .catch(function (error) {
        notify("Something went wrong");
      });
  }

  // ---------------------------ADD TEACHING DETAILS API-------------------------- //
  function teahingDetails() {

    let formdata = new FormData();
    formdata.append('class_or_category_id', ClassorCategoryId?.toString());
    formdata.append('subject_or_course_id', SubjectorCourseId?.toString());
    formdata.append('type', type);
    formdata.append('fees', fees);

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_BASEURL}/add_new_teacher_detailsSingle`,
      headers: {
        Authorization: "Bearer" + localStorage.getItem("api_token"),
      },
      data: formdata,
    };
    setLoadingSpinner(
      <RotatingLines
        strokeColor="white"
        strokeWidth="5"
        animationDuration="0.75"
        width="25"
        visible={true}
      />)
    axios(config)
      .then(function (response) {
        if (response.data.data) {
          setloaderStatus(<div>Data Not Found ...</div>);
        }
        if (response.data.statusCode == 200) {
          setTimenotify(response.data.message);
          setOnetimenotify(true);
          setTimeout(() => {
            navigate.push({
              pathname: '/teacher/teaching-details',
              state: { detail: response.data.id }
            });
          }, 2000);
        }
        else {
          setLoadingSpinner('Save')
          setTimenotify(response.data.message);
          setOnetimenotify(true);
        }
      })
      .catch(function (error) {
        notify(error?.response?.data?.message);
        setTimenotify(error.response.data.message);
      });
  }

  function handleClassCategoryStatus(eventclass: any) {
    setClassorCategoryId(eventclass.uniqueId)
    if (eventclass.type == "categories") {
      let subjectId: any = document.getElementById("subject_id");
      // console.log(subjectId, "subjectitititi")
      subjectId.value = ""
      setType("2");
      let extraData: any = []
      eventclass?.extraData.forEach((course: any) => {
        extraData?.push({ label: course?.name, value: course?.id })
      });
      setsubjectorcourses(extraData)
    } else {
      let subjectId: any = document.getElementById("subject_id");
      // console.log(subjectId, "subjectitititi")
      subjectId.value = ""
      setType("1");
      let extraData: any = []
      eventclass?.extraData.forEach((subject: any) => {
        extraData?.push({ label: subject?.title, value: subject?.id })
      });
      setsubjectorcourses(extraData)
    }
  }
  function handleSubjectCoursesStatus(event: any) {
    setSubjectorCourseId(event.value)
  }

  return (
    <>
      <ToastContainer limit={1} />
      <section className={`${st.pageContent}`}>
        <div className={`${st.leftContent} ${st.marginTopp}`}>
          <div className={`${cx.headerTitle}`}>
            <div className={`${cx.sticky}`}>
              <Row className={`${cx.titleBar}`}>
                <Col className={`col-2`}>
                  <NavLink to="/teacher/teaching-details" className={`${cx.back}`}>
                    <MdArrowBackIos />
                  </NavLink>
                </Col>
                <Col>
                </Col>
                <Col className="text-end">
                </Col>
              </Row>
            </div>
            <img src={bg} className={`${cx.bgShape}`} />
            <Col className="text-center"><img src={logo} className={`${cx.logo}`} />
            </Col>
          </div>

          <div className={`${cx.contentBody} mt-3`}>
            <Col lg={4} className={'m-auto'}>
              <h5 className={`${st.themeColor}`}>Add Teaching Details</h5>
              <p></p>
            </Col>
            <Col lg={4} className={'m-auto'}>
              <Form className={`${st.formFull}`}>

                <Form.Group className={`${st.formField}`} controlId="">
                  <Select key={props?.class_or_category_id}
                    onChange={handleClassCategoryStatus}
                    options={classData}
                  />
                </Form.Group>

                <Form.Group className={`${st.formField}`} controlId="">
                  <Select key={props?.class_or_category_id}
                    onChange={handleSubjectCoursesStatus}
                    options={subjectorcourses}
                    id="subject_id"
                  />
                </Form.Group>

                <Form.Group className={`${st.formField}`} controlId="">
                  <Form.Control min={0} type="number" placeholder={`Fees- ${localData?.currency.slice(4)}`}
                    defaultValue={fees}
                    key={props?.fees}
                    onChange={(e) => {
                      setFees(e.target.value)
                    }} />
                </Form.Group>

                <Form.Group className={`${cx.formField}`}>
                  <NavLink to="/teacher/teaching-details" className={`btn ${cx.grayBtn}`}>
                    Cancel
                  </NavLink>
                  <NavLink to="#" className={`btn ${cx.actionBtn}`}
                    onClick={teahingDetails}>
                    {loadingSpinner}
                  </NavLink>
                </Form.Group>
              </Form>
            </Col>
          </div>
        </div>
      </section>
    </>
  );
}